'use strict';

export default class SearchRoutePoint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.point.title || '',
            icao: props.point.icao || '',
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const {index, airports, direction, onSelect} = this.props;
        const that = this;

        $.widget( "app.autocomplete", $.ui.autocomplete, {
            _renderItem: function( ul, item ) {
                item.label = item.title;
                let result = this._super( ul, item );
                if ( item.icao ) {
                    result.append("<span>"+ item.icao +"</span>")
                }
                ul.addClass("inputbox-drop")
                return result;
            }
        });

        this.el = $(`.routePoint${direction}${index}`);
        this.el.autocomplete({
            minLength: 0,
            delay: 300,
            appendTo: ".page",
            source: airports,
            select: function (item, ui) {
                item.preventDefault();
                onSelect(ui.item);
                that.setState({
                    value: ui.item.title,
                    icao: ui.item.icao,
                })
            },
        }).bind('focus', function () {
            if (!$(this).val().trim()) {
                $(this).keydown();
            } else {
                $(this).next('.direction-code').hide();
                $(this).select();
            }
        }).bind('blur', function () {
            $(this).next('.direction-code').show();
        })
    }

    isEqual(o1, o2) {
        return JSON.stringify(o1) === JSON.stringify(o2);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {airports, point, error} = this.props;
        const {value} = this.state;
        let update = false;
        if(!this.isEqual(airports, nextProps.airports)) {
            this.el.autocomplete('option', 'source', nextProps.airports)
            this.el.autocomplete('option', 'delay', 10)
            update = true;
        }
        if(!this.isEqual(point, nextProps.point)) {
            this.setState({
                value: nextProps.point.title,
                icao: nextProps.point.icao,
            })
            update = true;
        }
        if(!this.isEqual(value, nextState.value)) update = true;
        if(!this.isEqual(error, nextProps.error)) update = true;
        return update;
    }

    handleChange(e) {
        const {onSelect} = this.props;

        let source = (request, response) => $.ajax({
            url: apiAction.apiUrl('autocomplete/airportOrCity'),
            dataType: "json",
            data: apiAction.prepareData(request),
            success: response,
        });

        let delay = 300;
        if(!e.target.value.trim()) {
            source = this.props.airports;
            delay = 10;
        }
        this.el.autocomplete('option', 'source', source);
        this.el.autocomplete('option', 'delay', delay);
        onSelect({});
        this.setState({
            value: e.target.value.trim(),
            icao: '',
        })
    }

    render() {
        const {index, direction, label, error} = this.props;
        const {value, icao} = this.state;
        return <div className={clsx(`search-inputbox direction-${direction}`, {error})}>
            <input type="text" placeholder={label} className={`routePoint${direction}${index}`} value={value} onChange={this.handleChange}/>
            <span className="direction-code">{icao}</span>
        </div>
    }
}
